import React from 'react';
import './Alert.css';

const Alert = ({ 
  children, 
  variant = 'info', 
  size = 'medium',
  dismissible = false,
  onDismiss,
  className = '',
  ...props 
}) => {
  const baseClasses = 'alert';
  const variantClasses = `alert-${variant}`;
  const sizeClasses = `alert-${size}`;
  
  const classes = [baseClasses, variantClasses, sizeClasses, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} {...props}>
      <div className="alert-content">
        {children}
      </div>
      {dismissible && (
        <button 
          className="alert-dismiss" 
          onClick={onDismiss}
          aria-label="Dismiss alert"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default Alert;
